import {schema} from 'normalizr'
import {articleSchema} from './article'
import {pollSchema} from './poll'
import {postSchema} from './post'
import {askSchema} from "./ask";
import {musicSchema} from "../music";
import {codiDocumentSchema} from "./document";

export const pinSchema = new schema.Entity(
    'pins',
    {
        owner: new schema.Union(
            {
                post: postSchema,
                ask: askSchema,
                article: articleSchema,
                poll: pollSchema,
                music: musicSchema,
                codi_document: codiDocumentSchema
            },
            '_type'
        )
    },
    {
        idAttribute: 'id'
    }
)
